import { render } from "./ApprovalsPending.vue?vue&type=template&id=2d79e402&scoped=true"
import script from "./ApprovalsPending.vue?vue&type=script&lang=js"
export * from "./ApprovalsPending.vue?vue&type=script&lang=js"

import "./ApprovalsPending.vue?vue&type=style&index=0&id=2d79e402&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d79e402"]])

export default __exports__